<!-- <app-app-navigation></app-app-navigation>
<app-login-page></app-login-page> -->

<mat-sidenav-container class="sidenav-container">

    <mat-sidenav #drawer class="sidenav" fixedInViewport [hidden]="!shouldRenderNav" [opened]="shouldRenderNav"
        [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'" [mode]="(isHandset$ | async) ? 'over' : 'side'">
        <mat-toolbar style="background-color: #7667F4; color: white;">
            <span>Menu</span>
        </mat-toolbar>
        <mat-nav-list>
            <ng-container *ngFor="let nav of sideNav">
                <mat-list-item [routerLink]="nav.routerLink" *ngIf="nav.shouldRender">
                    <mat-icon matListItemIcon class="text-dark m-2 ms-3">{{nav.iconString}}</mat-icon>
                    <div matListItemTitle>{{nav.title}}</div>
                </mat-list-item>
            </ng-container>
        </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
        <mat-toolbar style="background-color: #7667F4; color: white;" [hidden]="!shouldRenderNav">
            <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
                <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
            </button>
            <div class="d-flex justify-content-between align-items-center w-100">
                <img *ngIf="!logoLoading && !imageUrl" src="../assets/pulsy-logo.png" alt="pulsy logo"
                    style="width: 8%;" class="mx-auto">
                <img *ngIf="!logoLoading && imageUrl" [src]="imageUrl" alt="pulsy logo" style="width: 8%;"
                    class="mx-auto">
                <mat-spinner *ngIf="logoLoading" [diameter]="30" [strokeWidth]="3"
                    class="mx-auto mat-spinner"></mat-spinner>
                <button mat-button (click)="onLogout()" class="text-white">
                    <mat-icon>exit_to_app</mat-icon>
                    Logout
                </button>
            </div>
        </mat-toolbar>

        <router-outlet></router-outlet>

    </mat-sidenav-content>
</mat-sidenav-container>